import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import NotFound from "../NotFound";
import Dashboard from "./pages/dashboard/Dashboard";
import Learners from "./pages/learners/Learners";
import Courses from "./pages/courses/Courses";
import RewardRoutes from "./pages/rewards/RewardRoutes";
import Analytics from "./pages/analytics/Analytics";
import UserManagement from "./pages/user-management/UserManagement";
import ActionPlanRoutes from "./pages/action-plan/ActionPlanRoute";
import CertificateRoutes from "./pages/certificate-editor/CertificateRoutes";
import Clients from "./pages/clients/Client";
import Modules from "./pages/modules/Modules";
import Cohorts from "./pages/cohorts/Cohorts";
import LearningPath from "./pages/learningPath/LearningPath";
import RolesPrivilegesRoutes from "./pages/roles-and-priviledges/RolesPrivilegesRoutes";
import EmailEditorRoutes from "./pages/email/EmailEditorRoutes";
import ZoomRoutes from "./pages/zoom/ZoomRoutes";
import SettingsRoutes from "./pages/settings/SettingsRoutes";
import Feedback from "./pages/feedback/Feedback";
import ContentRoutes from "./pages/content-libary/ContentRoutes";
import ReportRoute from "./pages/report/ReportRoute";
import AdminMangementRoute from "./pages/admin-management/AdminMangementRoute";
import NotificationRoutes from "./pages/notifications/NotificationRoutes";
import Categories from "./pages/categories/Categories";
import AdminLayout from "./Layout";
import PrivateRoute from "../Auth/PrivateRoute";
import AdminLogin from "../Auth/AdminLogin";
import PermissionGate from "../../components/PermissionGate";

// Redirects to dashboard if user lacks the required view privilege
const ProtectedRoute = ({ slug, element }) => (
  <PermissionGate slug={slug} fallback={<Navigate to="/admin/dashboard" replace />}>
    {element}
  </PermissionGate>
);

const AdminRoutes = () => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const accountType = user?.role?.slug;
  const isClientAdmin = accountType === "client-admin";

  return (
    <Routes>
      <Route path="/login" element={<AdminLogin />} />
      <Route element={
        <PrivateRoute>
          <AdminLayout />
        </PrivateRoute>
      }>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/clients/*" element={<Clients />} />
        <Route path="/learners/*" element={<ProtectedRoute slug="learner-management.view" element={<Learners />} />} />
        <Route path="/categories/*" element={<ProtectedRoute slug="category-management.view" element={<Categories />} />} />
        <Route path="/course/*" element={<ProtectedRoute slug="course-management.view" element={<Courses />} />} />
        <Route path="/modules/*" element={<ProtectedRoute slug="module-management.view" element={<Modules />} />} />
        <Route path="/courses/analytics" element={<Analytics />} />
        <Route path="/cohort/*" element={<Cohorts />} />
        <Route path="/learning-path/*" element={<ProtectedRoute slug="learning-path-management.view" element={<LearningPath />} />} />
        {
          isClientAdmin &&
          <Route path="/report/*" element={<ReportRoute />} />
        }
        <Route path="/user-management/*" element={<UserManagement />} />
        <Route path="/rewards/*" element={<RewardRoutes />} />
        <Route path="/zoom/*" element={<ZoomRoutes />} />
        <Route path="/action-plan/*" element={<ProtectedRoute slug="learner-management.view" element={<ActionPlanRoutes />} />} />
        <Route path="/settings/*" element={<ProtectedRoute slug="system-settings-management.view" element={<SettingsRoutes />} />} />
        <Route path="/email/*" element={<EmailEditorRoutes />} />
        <Route path="/certificate/*" element={<CertificateRoutes />} />
        <Route path="/roles-and-privileges/*" element={<ProtectedRoute slug="role-management.view" element={<RolesPrivilegesRoutes />} />} />
        <Route path="/admins/*" element={<ProtectedRoute slug="admin-management.view" element={<AdminMangementRoute />} />} />
        <Route path="/feedback/*" element={<Feedback />} />
        <Route path="/content-library/*" element={<ProtectedRoute slug="content-management.view" element={<ContentRoutes />} />} />
        <Route path="/notifications/*" element={<ProtectedRoute slug="notification-management.view" element={<NotificationRoutes />} />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
